import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { styledRN } from "./styled";
import { FontAwesomeIconCtx } from "./platform";
import { Text, View } from "react-native";
import { useTheme } from "./theme";
const Icon = styledRN(View, {
    // @ts-expect-error ---
    fontSize: 50,
});
const Label = styledRN(Text, ({ color }) => ({
    fontFamily: "hiyllo",
    fontSize: 25,
    color
}));
const Hint = styledRN(Text, ({ color }) => ({
    fontFamily: "hiyllo",
    fontSize: 15,
    color
}));
const Centered = styledRN(View, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 5,
    height: "100%",
});
export const EmptySplash = React.memo(function (props) {
    const FontAwesomeIcon = React.useContext(FontAwesomeIconCtx);
    const theme = useTheme();
    const color = props.color ?? theme.foreground ?? "#ffffff";
    if (FontAwesomeIcon == null) {
        throw new Error("FontAwesomeIconCtx not provided");
    }
    return (_jsxs(Centered, { children: [_jsx(Icon, { children: _jsx(FontAwesomeIcon, { icon: props.icon, color: color, size: 50 }) }), _jsx(Label, { color: color, children: props.label }), props.hint != null ?
                _jsx(Hint, { color: color, children: props.hint })
                : null, props.afterElement] }));
});
